import { lazy } from 'react';

export const Clear = lazy(() => import('./Clear.component'));
